import React from "react";
import { find, map } from "lodash";

import NewsPageHeader from "~/components/NewsPageHeader";

import { useTranslationContext } from "~/context/TranslationContext";

const useGetCategoryNames = (newsCategories) => {
    const { activeCode } = useTranslationContext();

    const newsCatArr = map(newsCategories, (newsCategory) => {
        const translations = newsCategory.taxonomyDetails?.translatedName;
        const translation = find(translations, {
            languageCode: activeCode,
        })?.translation;

        if (translation) {
            return translation;
        }

        return newsCategory.name;
    });

    return newsCatArr.join(", ");
};

const NewsArticlePageHeader = ({ data }) => {
    const {
        wpNewsArticle: {
            title,
            newsCategories,
            articleOptions: { breadcrumbsAtTop },
        },
    } = data;

    const categories = useGetCategoryNames(newsCategories.nodes);

    return (
        <NewsPageHeader
            {...{ title, breadcrumbsAtTop }}
            category={categories}
        />
    );
};

export default NewsArticlePageHeader;
